module.exports = __webpack_public_path__ + "static/media/ashmi.cc649108.jpg";